import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormControlLabel, Radio } from 'edenred-ui';
import { useTheme } from 'styled-components';

import { InvoicingMethod } from '@epi-forms/helpers';
import { InvoicingMethodFieldProps } from '@epi-models/forms/Controls';

import { EmailAddressField } from '../../EmailAddressField';

export function EmailInvoiceField({
  readOnly,
  isActive
}: InvoicingMethodFieldProps) {
  const { altGray2, primaryBackColorLight10 } = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      border={`1px solid ${altGray2}`}
      px={3}
      pt={2}
      pb={4}
      bgcolor={isActive ? primaryBackColorLight10 : undefined}
    >
      <FormControlLabel
        value={InvoicingMethod.Email}
        control={<Radio />}
        label={t('controls.email_radio_label')}
        readOnly={readOnly}
        id="invoicing-method_email"
      />
      <EmailAddressField
        readOnly={readOnly}
        label={t('controls.email_address_label')}
        required={isActive}
        disabled={!isActive}
      />
    </Box>
  );
}
